import { z } from "zod";
import { QaTradeDecision } from "@remi/enums/qa-trade-decision";
import { TaskType } from "@remi/enums/task-type";

// The ops decision on an inspector's recommendation, confirming or disputing it; a flag is never a decision.
// Keyed on the submission AND its submittedAt, so a redone checklist is not decided by an earlier decision.
export const AssessQaResultsTaskAttemptSchema = z.object({
  type: z.literal(TaskType.ASSESS_QA_RESULTS),
  coveredProjectId: z.int(),
  checklistSubmissionId: z.string(),
  submittedAt: z.string(),
  decision: z.enum([QaTradeDecision.CORRECTIONS_NEEDED, QaTradeDecision.NO_CORRECTIONS_NEEDED]),
  // Absent when ops accepted the recommendation, and on decisions recorded before a reason was asked for.
  reason: z.string().trim().min(1).max(1000).optional(),
  // Stamped on a CORRECTIONS_NEEDED decision once the corrections it spawned or adopted exist: nothing else
  // records which QA visit a correction answers, and a covered project can be corrected more than once.
  correctionProjectIds: z.array(z.int()).min(1).optional(),
});
